import React from "react";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";
import BottomNavigation from "@mui/material/BottomNavigation";
import { useNavigate, useLocation } from "react-router-dom";
import TodayIcon from "@mui/icons-material/Today";
import RestaurantIcon from "@mui/icons-material/Restaurant";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import HomeIcon from "@mui/icons-material/Home";
import PeopleIcon from "@mui/icons-material/People";
import { makeStyles } from "tss-react/mui";
import ROUTES from "../../routes/routes";
import { useAuth } from "../../context-providers/auth-provider";
import { useSettings } from "../../context-providers/settings-provider";

const useStyles = makeStyles()((theme) => ({
  bottomBar: {
    width: "100%",
    height: "80px",
    position: "static",
    "@media (min-height: 600px)": {
      position: "fixed",
    },
    bottom: 0,
    background: theme.palette.primary.main,
    zIndex: 1,
  },

  action: {
    minWidth: "60px",
    background: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    transition: "all 0.5s",
  },

  selected: {
    minWidth: "76px",
    color: `${theme.palette.secondary.main} !important`,
    fontSize: "16px !important",
    background: `${theme.palette.primary.contrastText} !important`,
    boxShadow: "none !important",
  },

  label: {
    background: "none !important",
    fontSize: "14px",
  },
}));

export default function BottomBar() {
  const navigate = useNavigate();
  const location = useLocation();
  const { isVerified } = useAuth();
  const { publicSettings } = useSettings();
  const { classes } = useStyles();

  if (!isVerified() || !publicSettings || !publicSettings.username) {
    return <div />;
  }
  const locationValue = `/${location.pathname.split("/")[1]}`;

  const actionClasses = {
    selected: classes.selected,
    root: classes.action,
    label: classes.label,
  };

  return (
    <BottomNavigation
      value={locationValue}
      onChange={(event: any, newLocation: any) => {
        navigate(newLocation);
      }}
      showLabels
      className={classes.bottomBar}
    >
      <BottomNavigationAction
        classes={actionClasses}
        label="Recipes"
        value={ROUTES.RECIPES}
        icon={<RestaurantIcon />}
      />
      <BottomNavigationAction
        classes={actionClasses}
        label="Planner"
        value={ROUTES.PLANNER}
        icon={<TodayIcon />}
      />
      <BottomNavigationAction
        classes={actionClasses}
        label="Home"
        value={ROUTES.HOME}
        icon={<HomeIcon />}
      />
      <BottomNavigationAction
        classes={actionClasses}
        label="Shopping"
        value={ROUTES.SHOPPING}
        icon={<ShoppingCartIcon />}
      />
      <BottomNavigationAction
        classes={actionClasses}
        label="Friends"
        value={ROUTES.FRIENDS}
        icon={<PeopleIcon />}
      />
    </BottomNavigation>
  );
}
